<ng-container *ngIf="searchState && searchState.products && searchState.isSuccessful; else errorResult">
	<ng-container *ngIf="products?.length; else noResults">
		<div scrollIntoView class="scrollAnchor" *ngIf="searchState.scrollToTop"></div>
		<div *ngIf="shouldShowNewLayoutOfProductCategoriesAndFilters" class="page-header">
			<a
				class="backToBoosts"
				[routerLink]="boostOffersLink"
				cdxButton
				fillStyle="outline"
				[startSlotActive]="true"
				*ngIf="!!boostOfferTag"
			>
				<cdx-svg-icon name="chevron-left" fill="green" size="small" start></cdx-svg-icon>
				Back to Boosts</a
			>
			<search-results-header
				*ngIf="((breakPointService.device$ | async) !== device.MOBILE || !isEmbeddedInMobileApp) && !!title"
				class="results-header"
				[dasFacets]="searchState?.dasFacets"
				[dasFacetsRoute]="dasFacetsRoute$ | async"
				[dasFacetsQueryParams]="dasFacetsQueryParams$ | async"
				[currentShelf]="searchStoreService.breadcrumb?.shelf"
				[shouldShowNewCategoriesList]="shouldShowNewLayoutOfProductCategoriesAndFilters"
				[heading]="title"
				[totalItems]="searchState.products.totalItems"
			></search-results-header>
		</div>

		<div class="contentContainer" [ngClass]="{'search-results': isSearchTarget}">
			<div [ngClass]="{'content-header': shouldShowNewLayoutOfProductCategoriesAndFilters}">
				<search-category-list
					*ngIf="shouldShowNewLayoutOfProductCategoriesAndFilters && (breakPointService.device$ | async) === device.MOBILE && isEmbeddedInMobileApp"
					class="search-category-list"
					[dasFacets]="searchState?.dasFacets"
					[dasFacetsRoute]="dasFacetsRoute$ | async"
					[dasFacetsQueryParams]="dasFacetsQueryParams$ | async"
					[currentShelf]="searchStoreService.breadcrumb?.shelf"
				>
				</search-category-list>
			</div>

			<search-results-header
				*ngIf="isSearchTarget && ((breakPointService.device$ | async) !== device.MOBILE && !isEmbeddedInMobileApp) && !!title"
				class="search-results-header"
				[heading]="title"
			></search-results-header>

			<search-filter-combo
				*ngIf="shouldShowNewSearchFilter; else oldSearchFilter"
				[filterGroups]="filterGroups"
				[selectedFilters]="searchState?.selectedFilters"
				[categories]="categories"
				[selectedCategories]="selectedCategories"
				[optionsRevealApproach]="currentDevice === device.MOBILE ? 'modal' : 'dropdown'"
				[sortOptions]="searchState.sortOptions"
				[currentSortOption]="searchState.currentSortOption"
				[totalItems]="searchState.products.totalItems"
				[variant]="layoutVariant"
				(filterChange)="onFiltersChanged($event)"
				(sortChange)="onSortChanged($event)"
				(categoryChange)="onCategoriesChanged($event)"
			></search-filter-combo>

			<ng-template #oldSearchFilter>
				<search-das-filter
					*ngIf="!layoutExtended"
					[boostOfferTag]="boostOfferTag"
					[dasFacets]="searchState?.dasFacets"
					[dasFacetsRoute]="dasFacetsRoute$ | async"
					[dasFacetsQueryParams]="dasFacetsQueryParams$ | async"
					[filterGroups]="filterGroups"
					[selectedFilters]="searchState?.selectedFilters"
					[marginTop]="piesHeaderHeight"
					(filterChange)="onFilterChanged($event)"
					(facetChange)="onFacetChanged($event)"
					(clearFilters)="onClearFilters()"
				></search-das-filter>
			</ng-template>

			<main class="contentContainer-main">
				<a
					class="backToBoosts"
					[routerLink]="boostOffersLink"
					cdxButton
					fillStyle="outline"
					[startSlotActive]="true"
					*ngIf="!shouldShowNewSearchFilter && !!boostOfferTag"
				>
					<cdx-svg-icon name="chevron-left" fill="green" size="small" start></cdx-svg-icon>
					Back to Boosts</a
				>

				<search-pies-header
					*ngIf="!shouldShowNewSearchFilter"
					#piesHeader
					[heading]="title"
					[filterGroups]="filterGroups"
					[selectedFilters]="searchState.selectedFilters"
					[sortOptions]="searchState.sortOptions"
					[currentSortOption]="searchState.currentSortOption"
					[totalItems]="searchState.products.totalItems"
					[boostOfferTag]="boostOfferTag"
					[showDynamicContent]="searchState.currentPage === 1"
					[enableSwitchToggleShowInStock]="isTargetBrowseOrSearch && (isShowInStockItemsOnlyFeatureEnabled$ | async)"
					[enableHideSwitchToggleForOOS]="isHideSwitchToggleForOOSEnabled"
					[inStockProductsOnlyFromRoute]="inStockProductsOnlyFromRoute"
					(removeFilter)="onRemoveFilter($event)"
					(removeAllFilters)="onRemoveAllFilters()"
					(sortChange)="onSortChanged($event)"
					(inStockProductsOnlyToggleChange)="onInStockProductsOnlyToggleChange($event)"
				>
					<div
						dynamic-content
						#dynamicContentPanel
						id="dynamic-content-panel"
						class="dynamic-content-canvas"
					></div>
				</search-pies-header>
				<product-grid
					[searchSortOptions]="searchState?.sortOptions"
					[loading]="searchState.loading"
					[productIndexOffset]="productIndexOffset$ | async"
					[cppItemCount]="cppItemCount$ | async"
					[products]="products"
					[isshopper]="isShopper"
					[isloggedin]="isLoggedIn"
					[department]="department"
					[aisle]="aisle"
					[shelf]="shelf"
					[target]="target"
					[searchQuery]="searchQuery"
					[totalItemsCount]="searchState?.products?.totalItems"
					[maxBoughtBeforePosition]="maxBoughtBeforePosition"
					[selectedFilters]="searchState?.selectedFilters"
					[shouldColumnsExtended]="layoutExtended"
				>
				</product-grid>
				<ng-container *ngIf="isInfiniteLoadMoreEnabled; then infiniteLoadMore else paginate" />
				<ng-template #paginate>
					<search-footer
						[totalItems]="searchState.products.totalItems"
						[itemsPerPageCollection]="itemsPerPageCollection"
						[minimumPageSize]="minimumPageSize"
						[itemsCount]="searchState.products?.items?.length"
						[currentPage]="searchState.currentPage"
						[currentPageSize]="searchState.currentPageSize"
						[canChangePageSize]="!isTargetBrowseOrSearch"
					></search-footer>
				</ng-template>
				<ng-template #infiniteLoadMore>
					<cdx-load-more
						[currentlyShowing]="searchState.cumulativeProducts?.items?.length"
						[totalItems]="searchState.products.totalItems"
						[loading]="isNewPageLoading$ | async"
						(loadMore)="loadMore()"
					>
						Load more
					</cdx-load-more>
				</ng-template>
				<product-brand-suggestion
					[brands]="searchState.brandSuggestions"
					[target]="target"
					[heading]="title"
				></product-brand-suggestion>
				<div id="dynamic-content-bottom-panel" class="dynamic-content-canvas"></div>
				<div id="countdown_emb_search" *ngIf="searchQuery" class="feedbackComponent"></div>
			</main>
		</div>
	</ng-container>
	<ng-template #noResults>
		<search-no-results></search-no-results>
	</ng-template>
</ng-container>

<ng-template #errorResult>
	<search-error class="contentContainer" />
</ng-template>
<div #scrollAnchor></div>
